export default __webpack_public_path__ + "static/media/592.cb6ebe69.png";